export var parseTimeRanges=function(r){for(var e=[],t=0;t<r.length;t++)e.push({start:r.start(t),end:r.end(t)});return e};